import consumer from "./consumer";

document.addEventListener("DOMContentLoaded", () => {
  const bellIcon = document.querySelector(
    ".notification-center .nc-system-wrapper .nc-system"
  );

  if (bellIcon) {
    consumer.subscriptions.create("NotificationsChannel", {
      received() {
        bellIcon?.classList.add("unread");
      },
    });
  }
});
